import { render, staticRenderFns } from "./NLP.vue?vue&type=template&id=0135d83a&lang=pug&"
import script from "./NLP.vue?vue&type=script&lang=js&"
export * from "./NLP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports